module.exports = __webpack_public_path__ + "static/media/help-disk-privacy-policy.6cc3f5df.svg";